import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/output_video.webm")